import { NgModule } from '@angular/core';

import { SharedModule } from '../../../common/modules/shared';

import { ChildrenListComponent } from './1-children-list/ChildrenListComponent';
import { ActivitesListComponent } from './3-activites-list/ActivitesListComponent';
import { ExcursionsComponent } from './4-excursions/ExcursionsComponent';
import { BusOptionComponent} from './5-bus-option/BusOptionComponent';
import { PaymentComponent } from './6-payment/PaymentComponent';
import { FinishComponent } from './6-finish/FinishComponent';
import { ViewBookingComponent } from './view-booking/ViewBookingComponent';
import { AttendanceComponent } from './attendance/AttendanceComponent';
import { DialogModule, CalendarModule } from 'primeng/primeng';

import { bookingRouting } from './BookingRouting';
import { QuestionAnswerComponent } from './2-Q&A/QuestionAnswerComponent';

@NgModule({
    imports: [
        SharedModule,
        DialogModule,
        CalendarModule,
        bookingRouting,
    ],
    declarations: [
        ChildrenListComponent,
        ActivitesListComponent,
        QuestionAnswerComponent,
        ExcursionsComponent,
        BusOptionComponent,
        PaymentComponent,
        FinishComponent,
        ViewBookingComponent,
        AttendanceComponent
    ]
})

export class BookingModule { }


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/BookingModule.ts